import React, { useEffect, useState, useMemo } from "react";
import { Container, Input, Table, FormGroup, Label } from "reactstrap";
import { Formik, Form, Field } from "formik";
import Modal from "react-modal"
import { getCustomStyles } from "../../share/ModalStyle";
import { Loading } from "../../share/loading";
import { useTable, useSortBy, useGlobalFilter, usePagination } from "react-table";
import * as Yup from "yup";
import "../../share/form.css";
import './ProposalStyle.css'
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css'
import { NumberWithCommas } from "../../share/NumberWithCommas";
import { RenderCustomHeader } from "../../share/RenderCustomHeader";
import { ConvertDateToThaiBuddhist } from "../../share/ConvertDateToThaiBuddhist";
import { ConvertDateFormat } from "../../share/ConvertDateFormat";
import { CgClose } from "react-icons/cg";
import { NumericFormat } from 'react-number-format';
import { CustomInputNumeric } from '../../share/CustomInputNumeric'
import Swal from "sweetalert2";



export function ProposedToTheSubCommittee4ApproveViewComponent() {

    const myCustomStyles = getCustomStyles()
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    console.log("data", data);
    const [meetingDate, setMeetingDate] = useState("")
    const [meetingYear, setMeetingYear] = useState("")
    const [meetingNo, setMeetingNo] = useState("")
    const [meetingYearSelect, setMeetingYearSelect] = useState([])
    const [meetingNoSelect, setMeetingNoSelect] = useState([])
    const user = JSON.parse(localStorage.getItem("userData"));
    const [modalRecordBorrow, setModalRecordBorrow] = useState(false);
    const ToggleModalRecordBorrow = () => setModalRecordBorrow(!modalRecordBorrow)
    const [selectTestTimeId, setSelectTestTimeId] = useState(null)
    const [selectDetailTestTimeId, setSelectDetailTestTimeId] = useState(null);
    console.log("selectDetailTestTimeId", selectDetailTestTimeId)
    console.log()
    const selectOption = [{ id: "1", value: "อนุมัติ" }, { id: "2", value: "ไม่อนุมัติ" }]
    // console.log("meetingNo", meetingNo)
    // console.log("meetingYear", meetingYear)
    // console.log("meetingDate", meetingDate)
    // console.log("meetingYearselect", meetingYearSelect)
    // console.log("data",data)

    useEffect(() => {
        async function GetMeetingForSelect() {
            setLoading(true)
            try {
                let res = await fetch(`api/ProposalBorrow/getMeetingNoSelectTest`);
                let resJson = await res.json();
                console.log(resJson.dataenum)
                setMeetingNoSelect(resJson.dataenum);
                // console.log("borrowInfo", resJson.dataenum);
            } catch (e) {
                console.log("err =>", e)

            } finally {
                setLoading(false)
            }
        }
        GetMeetingForSelect()

    }, [])
    function GetClassId(testTimeId) {
        console.log("testTimeId")
        setSelectTestTimeId(testTimeId)
        setSelectDetailTestTimeId(data.find((item) => {
            return item.testTimeId === testTimeId
        }))
        ToggleModalRecordBorrow()
    }

    function useInstance(instance) {
        // console.log("instance", instance);
        const { allColumns } = instance;
        // setDataForCheck(data);
        // setDataForCheck(data);
        let rowSpanHeaders = [];


        allColumns.forEach((column, i) => {
            // console.log("column",column)
            const { id, enableRowSpan } = column;
            // console.log("id",id)
            if (enableRowSpan !== undefined) {
                rowSpanHeaders = [
                    ...rowSpanHeaders,
                    { id, topCellValue: null, topCellIndex: 0, }
                ];
            }
        });
        // console.log("rowSpanHeaders",rowSpanHeaders)

        Object.assign(instance, { rowSpanHeaders });
    }

    const columns = useMemo(
        () => [

            {
                Header: "ข้อมูลผู้ขอกู้",
                columns: [
                    {
                        Header: "ลำดับ",
                        accessor: 'No',
                        id: "No",
                        enableRowSpan: true,
                        // accessor: (_row, i) => i + 1,
                        // Cell: (row) => {
                        //   return <div>{Number(row.row.id) + 1}</div>;
                        // },
                        // accessor: "borrowId",
                    },
                    {
                        Header: "เลขที่คำขอ",
                        accessor: "borrowNumber",
                        enableRowSpan: true,


                    },
                    {
                        Header: "ผู้ขอกู้",
                        accessor: "employee",
                        enableRowSpan: true,

                    },
                    {
                        Header: "ประเภทผู้กู้ยืม",
                        accessor: "borrowType",
                        enableRowSpan: true
                    },
                    {
                        Header: "ประเภทกิจการ",
                        accessor: "businessType",
                        enableRowSpan: true,

                    },
                    {
                        Header: "สาขาอาชีพ",
                        accessor: "",
                        enableRowSpan: true,
                        Cell: ({ value }) => (
                            <>{value ? value : "-"}</>
                        ),

                    },

                    {
                        Header: "จำนวนลูกจ้างทั้งสิ้น (คน)",
                        accessor: "employeeAmount",
                        Cell: ({ value }) => {
                            // console.log("value",value)
                            return (
                                <>{value ? NumberWithCommas(Number(value)) : "-"}</>
                            )
                        },
                        enableRowSpan: true,

                    },
                    {
                        Header: "ประเภทการทดสอบฯ",
                        accessor: "inOutTypeName",
                        Cell: ({ value }) => (
                            <>{value ? value : "-"}</>
                        ),
                        enableRowSpan: true,

                    },
                ]
            },

            {
                Header: "รายละเอียดการขอกู้ยืมเงิน",
                columns: [
                    {
                        Header: "สาขาอาชีพ",
                        accessor: "testId",
                        Cell: ({ row, value }) => (
                            <>{row.original.lawOccupationName}</>
                        ),
                        enableRowSpan: true

                    },
                    {
                        Header: "สาขา",
                        accessor: "testOccupationName",
                        enableRowSpan: true,
                    },
                    {
                        Header: "ระดับ",
                        accessor: "testOccupationLevel",
                        enableRowSpan: true
                    },

                    {
                        Header: "ระยะเวลาการฝึกอบรม (ขั่วโมง)",
                        accessor: "dayAmount",
                        Cell: ({ row, value }) => (
                            <>
                                <div>({value} วัน)</div>
                            </>
                        ),
                        enableRowSpan: true
                    },
                    {
                        Header: "วันที่เริ่มฝึก",
                        accessor: "startDate",
                        Cell: ({ row, value }) => (
                            <>
                                <div>{value}</div>
                                (ทดสอบครั้งที่ {row.original.testItem})
                            </>
                        ),
                        enableRowSpan: true
                    },
                    {
                        Header: "วันที่จบการฝึก",
                        accessor: "endDate",
                        Cell: ({ row, value }) => (
                            <>
                                <div>{value}</div>
                                (ทดสอบครั้งที่ {row.original.testItem})
                            </>
                        ),
                        enableRowSpan: true
                    },
                    {
                        Header: "จำนวน (คน)",
                        accessor: "testEmployeeAmount",
                        enableRowSpan: true
                    },
                    {
                        Header: "วงเงินที่ขอกู้ (บาท)",
                        accessor: "payment",
                        Cell: ({ value }) => (
                            <>{value ? NumberWithCommas(value) : "-"}</>
                        ),
                        enableRowSpan: true
                    },
                    {
                        Header: "",
                        accessor: "testTimeId",
                        Cell: (cellInfo) => {
                            // console.log("cellInfo",cellInfo.value)
                            return (
                                <button
                                    type="button"
                                    className="my-3 btn-green mx-2"
                                    onClick={() => GetClassId(cellInfo.value)}
                                >
                                    บันทึกผลการพิจารณา
                                </button>
                            )

                        },
                        enableRowSpan: true
                    },

                ]
            },
            {
                Header: "หน่วยงานที่รับคำขอกู้ยืม",
                accessor: "site",
                enableRowSpan: true
            }

        ],
        [data]
    );


    // const arr = [
    //     { id: 1, No: 3, testId: "81", testDetailId: "81" },
    //     { id: 2, No: 3, testId: "81", testDetailId: "82" },
    //     { id: 3, No: 3, testId: "81", testDetailId: "81" }
    //   ];

    //   for (let i = 0; i < arr.length; i++) {
    //     if (i % 2 === 0) { // even index
    //       arr[i].testDetailId = "X";
    //     } else { // odd index
    //       arr[i].testDetailId = "Y";
    //     }
    //   }

    //   console.log(arr);
    useEffect(() => {
        GetBorrowFour()
    }, [meetingNo, meetingYear, meetingDate])
    async function GetBorrowFour() {
        setLoading(true)
        try {
            let res = await fetch(`api/ProposalBorrow/getResultProposalTest/${meetingNo}/${meetingYear}/${meetingDate}`);
            let resJson = await res.json();
            let newData = [];
            let testOccupationArr = [];
            console.log("resJson.dataenum", resJson.dataenum)
            await resJson.dataenum?.forEach((borrow, index) => {
                borrow.lawOccupationTests?.forEach((lawOccupation) => {
                    lawOccupation?.lawOccupationTestDetails?.forEach((testDetail) => {
                        // console.log("testDetail",testDetail)
                        testOccupationArr.push({
                            No: index + 1,
                            testDetailId: testDetail.testDetailId,
                            testOccupationName: testDetail.testOccupationName,
                            testOccupationLevel: testDetail.testOccupationLevel,
                        })

                    })
                    // console.log("lawOccupation", lawOccupation)
                    lawOccupation.lawOccupationTestTimes?.forEach((testTime) => {
                        newData.push({
                            No: index + 1,
                            borrowId: borrow.borrowId,
                            borrowNumber: borrow.borrowNumber,
                            employee: borrow.employee,
                            borrowType: borrow.borrowType,
                            businessType: borrow.businessType,
                            employeeAmount: borrow.employeeAmount,
                            testDetailId: lawOccupation.testDetailId,
                            //หน่วยงานที่รับคำขอกู้
                            site: borrow.site,
                            //หลักค้ำประกัน
                            position: borrow.position,
                            name: borrow.name,
                            testId: lawOccupation.testId,
                            inOutTypeName: lawOccupation.inOutTypeName,

                            lawOccupationId: lawOccupation.lawOccupationId,
                            lawOccupationName: lawOccupation.lawOccupationName,
                            // testOccupationName: lawOccupation.testOccupationName,
                            // testOccupationLevel: lawOccupation.testOccupationLevel,
                            // testDetailId : lawOccupation.testDetailId,



                            dayAmount: testTime.dayAmount,
                            startDate: testTime.startDate,
                            endDate: testTime.endDate,
                            testEmployeeAmount: testTime.employeeAmount,
                            testTimeId: testTime.testTimeId,
                            payment: testTime.payment,
                            testItem: testTime.testItem, //จำนวนครั้งที่ดำเนินการทดสอบ
                            amountApprove: testTime.amountApprove,
                            statusApprove: testTime.statusApprove,
                        })
                    })
                })
            })
            let mergeData = [];
            // console.log("testOccupationArr",testOccupationArr);
            // console.log("newData",newData)
            mergeData = newData.map(obj => {

                const index = testOccupationArr.findIndex(el => el["testDetailId"] === obj["testDetailId"]);
                const { testOccupationName, testOccupationLevel } = index !== -1 ? testOccupationArr[index] : {};

                return {
                    ...obj,
                    testOccupationName,
                    testOccupationLevel
                };
            });

            // console.log("mergeData",mergeData)
            // setData(mergeData.sort((a, b) => a.testTimeId - b.testTimeId))
            // setData(mergeData.sort((a, b) => {
            //     if (a.testTimeId !== b.testTimeId) {
            //         return a.testTimeId - b.testTimeId;
            //     } else {
            //         return a.testDetailId - b.testDetailId;
            //     }
            // }));
            mergeData.sort((a, b) => {
                if (a.No !== b.No) {
                    return a.No - b.No;
                } else {
                    return a.testTimeId - b.testTimeId;
                }
            })
            setData(mergeData);
            // setData(resJson.dataenum);
            // console.log("borrowInfo", resJson.dataenum);
        } catch (e) {
            console.log("err =>", e)

        } finally {
            setLoading(false)
        }
    }

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        rowSpanHeaders,

        page,
        // nextPage,
        // previousPage,
        // canNextPage,
        // canPreviousPage,
        // pageOptions,
        // gotoPage,
        // pageCount,
        setPageSize,
        state,
        setGlobalFilter
    } = useTable({
        columns,
        data
    },
        (hooks) => { hooks.useInstance.push(useInstance) },
        useGlobalFilter,
        useSortBy,
        usePagination
    );
    const { globalFilter, pageIndex, pageSize } = state

    // const validateSchema = Yup.object().shape({

    // })
    const fromInitialValues = {
        meetingNo: "",
        meetingYear: "",
        meetingDate: ""
    }
    const recordBorrowInititalValue = {
        userApprove: user.fullName,
        borrowId: selectDetailTestTimeId?.borrowId ?? "",
        testId: selectDetailTestTimeId?.testId ?? "",
        TestTimeId: selectTestTimeId,
        amount: selectDetailTestTimeId?.payment ?? "",
        approveStatus: selectDetailTestTimeId?.statusApprove ?? "",
        approveAmount: selectDetailTestTimeId?.amountApprove ? selectDetailTestTimeId?.amountApprove : ""
    }
    const recordBorrowValidationSchema = Yup.object().shape({
        approveStatus: Yup.string().oneOf(["1", "2"]).required("กรุณาระบุ"),
        approveAmount: Yup.string().when("approveStatus", {
            is: "1",
            then: Yup.string().required("กรุณาระบุจำนวนเงิน"),
        }),
    })

    const recordBorrowOnsubmit = async (values, actions) => {
        if (Number(values.approveAmount.replace(/,/g, '')) > values.amount) {
            Swal.fire({
                icon: "warning",
                title: "บันทึกข้อมูลไม่สำเร็จ",
                html: `เนื่องจากจำนวนเงินที่อนุมัติ มีจำนวนมากกว่าวงเงินที่ขอกู้`,
                confirmButtonColor: "#0A66C2",
                confirmButtonText: "ตกลง",
            })
        } else {
            Swal.fire({
                icon: "info",
                title: "ยืนยันการบันทึกข้อมูลหรือไม่ ?",
                html: ``,
                confirmButtonColor: "#0A66C2",
                confirmButtonText: "ตกลง",
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {

                        let res = await fetch("api/ProposalBorrow/recordResultProposalTrainTest", {
                            method: "POST",
                            headers: { "Content-type": "application/json" },
                            body: JSON.stringify(values)
                        })
                        let resJson = await res.json();
                        if (resJson.status === 1) {
                            Swal.fire({
                                icon: "success",
                                title: "บันทึกข้อมูลสำเร็จ",
                                confirmButtonColor: "#0A66C2",
                                confirmButtonText: "ตกลง",
                            }).then(async (result) => {
                                if (result.isConfirmed) {
                                    await GetBorrowFour()
                                    ToggleModalRecordBorrow()
                                    setSelectDetailTestTimeId(null)
                                }
                            })
                        } else {
                            Swal.fire({
                                icon: "error",
                                title: "มีบางอย่างผิดปกติ",
                                confirmButtonColor: "#0A66C2",
                                confirmButtonText: "ตกลง",
                            })
                        }
                        GetBorrowFour()

                    } catch (e) {
                        console.log("err =>", e)
                    }
                }
            })

        }

    }



    return (
        <Formik
            initialValues={fromInitialValues}
            enableReinitialize
        >
            {({ values, errors, touched, setFieldValue, handleBlur, handleChange }) => {

                async function getYearForSelect(e) {
                    let postData = new FormData()
                    postData.append("meetingNo", e.target.value)
                    console.log("meetingNo", e.target.value)
                    try {
                        let res = await fetch("api/ProposalBorrow/getMeetingYearSelectTest", {
                            method: "POST",
                            body: postData
                        })
                        let resJson = await res.json()
                        // console.log("resjson",resJson.dataenum)
                        setMeetingYearSelect(resJson.dataenum)
                    } catch (e) {
                        console.log("err", e)
                    }
                }
                return (
                    <Container>
                        {!loading ? (
                            <>
                                <Modal
                                    isOpen={modalRecordBorrow}
                                    onRequestClose={ToggleModalRecordBorrow}
                                    style={myCustomStyles}
                                >
                                    <div className="d-flex justify-content-between align-items-center w-100">
                                        <h3 className="w-100" style={{ color: "#0E527E", maxWidth: "960px", width: "100%" }}>บันทึกผลการพิจารณา</h3>
                                        <CgClose onClick={ToggleModalRecordBorrow} className="style-iconmodal" />
                                    </div>
                                    <hr />
                                    <Formik
                                        initialValues={recordBorrowInititalValue}
                                        validationSchema={recordBorrowValidationSchema}
                                        onSubmit={recordBorrowOnsubmit}
                                        enableReinitialize
                                    >
                                        {({ values, errors, touched, setFieldValue, handleBlur, handleChange, handleSubmit }) => {
                                            return (
                                                <Form autoComplete="off" className="px-5">
                                                    <div>
                                                        <FormGroup>
                                                            <h5>ข้อมูลผู้ขอกู้</h5>
                                                        </FormGroup>

                                                        <FormGroup>
                                                            เลขที่คำขอ
                                                            <span className="mx-1 input-color">{selectDetailTestTimeId?.borrowNumber}</span>
                                                        </FormGroup>
                                                        <FormGroup>
                                                            ชื่อผู้ขอกู้
                                                            <span className="mx-1 input-color">{selectDetailTestTimeId?.employee}</span>
                                                        </FormGroup>
                                                        <FormGroup>
                                                            สาขาอาชีพ
                                                            <span className="mx-1 input-color">{selectDetailTestTimeId?.lawOccupationName}</span>
                                                            ทดสอบครั้งที่
                                                            <span className="mx-1 input-color"> {selectDetailTestTimeId?.testItem} </span>
                                                        </FormGroup>
                                                        <FormGroup>
                                                            วันที่เริ่มฝึก
                                                            <span className="mx-1 input-color">{selectDetailTestTimeId?.startDate}</span>
                                                            วันที่สิ้นสุดการฝึก
                                                            <span className="mx-1 input-color">{selectDetailTestTimeId?.endDate}</span>
                                                        </FormGroup>
                                                        <FormGroup>
                                                            วงเงินที่ขอกู้
                                                            <span className="mx-1 input-color">{NumberWithCommas(Number(selectDetailTestTimeId?.payment))}</span>
                                                            บาท
                                                        </FormGroup>

                                                    </div>
                                                    <FormGroup>
                                                        <Label>สถานะ</Label>
                                                        <Input
                                                            type="select"
                                                            name="approveStatus"
                                                            id="approveStatus"
                                                            className={`rounded-pill input-color text-center ${errors.approveStatus ? "input-error" : ""}`}
                                                            // className="rounded-pill input-color text-center"
                                                            onChange={(e) => {
                                                                handleChange(e)
                                                                if (e.target.value !== "1") {
                                                                    setFieldValue("approveAmount", "")
                                                                }

                                                            }}
                                                            onBlur={handleBlur}
                                                            value={values.approveStatus}

                                                        >
                                                            <option defaultValue={"กรุณาเลือก"}>กรุณาเลือก</option>
                                                            {selectOption.map((item) => (
                                                                <option key={item.id} value={item.id}>{item.value}</option>
                                                            ))}
                                                        </Input>
                                                    </FormGroup>

                                                    <FormGroup>
                                                        <Label>จำนวนเงินที่อนุมัติ</Label>
                                                        <Field name="approveAmount">
                                                            {({ field, meta, form: { setFieldValue, values } }) => (
                                                                <NumericFormat
                                                                    {...field}
                                                                    isAllowed={false}
                                                                    allowLeadingZeros
                                                                    thousandSeparator=","
                                                                    decimalScale={2}
                                                                    isNumericString={true}
                                                                    displayType="number"
                                                                    disabled={values.approveStatus !== "1" ? true : false}
                                                                    value={values.approveAmount}
                                                                    // format={(value) => value.toLocaleString()}
                                                                    customInput={CustomInputNumeric}
                                                                    onValueChange={(values, sourceInfo) => {
                                                                        setFieldValue(field.name, values.value)
                                                                    }}
                                                                    className={meta.error && meta.touched ? "input-error" : ""}
                                                                />

                                                            )}
                                                        </Field>
                                                    </FormGroup>


                                                    <div className="d-flex justify-content-center align-items-center">
                                                        <button disabled={selectDetailTestTimeId?.amountApprove ? true : false} className="btn-blue w-25 mx-2">บันทึก</button>
                                                        <button className="btn-red w-25 mx-2" onClick={() => ToggleModalRecordBorrow()}>ยกเลิก</button>
                                                    </div>
                                                </Form>
                                            )
                                        }}


                                    </Formik>

                                </Modal>

                                <div className="d-flex justify-content-center align-items-center mb-2">
                                    <Form
                                        className="d-flex align-items-center justify-content-end w-75"
                                        // onSubmit={formik.handleSubmit}
                                        autoComplete="off"
                                    >
                                        <div className="d-flex align-items-center justify-content-start w-50 mx-1">
                                            <span className="w-75 text-center">ครั้งที่</span>
                                            <Input
                                                name="meetingNo"
                                                type="select"
                                                className="text-center w-100 rounded-pill input-color"
                                                onChange={(e) => {
                                                    handleChange(e)
                                                    getYearForSelect(e)
                                                    setMeetingNo(e.target.value)
                                                }}
                                                onBlur={handleBlur}
                                                value={values.meetingNo}
                                            >
                                                <option defaultValue={"กรุณาเลือก"}>
                                                    กรุณาเลือก
                                                </option>
                                                {meetingNoSelect.map((item, k) => (
                                                    <option key={k} value={item.meetingNo}>
                                                        {item.meetingNo}
                                                    </option>
                                                ))}
                                            </Input>

                                        </div>
                                        <div className="d-flex align-items-center justify-content-start w-50 mx-1">
                                            <span className="w-75 text-center">ปี</span>
                                            <Input
                                                name="meetingYear"
                                                type="select"
                                                className="text-center w-100 rounded-pill input-color"
                                                onChange={(e) => {
                                                    handleChange(e)
                                                    setMeetingYear(e.target.value)
                                                }}
                                                onBlur={handleBlur}
                                                value={values.meetingYear}
                                            >

                                                <option defaultValue={"กรุณาเลือก"}>
                                                    กรุณาเลือก
                                                </option>
                                                {meetingYearSelect.map((year, i) => (
                                                    <option key={i} value={year.meetingYear}>
                                                        {year.meetingYear}
                                                    </option>
                                                ))}
                                            </Input>

                                        </div>
                                        <div className="d-flex align-items-center justify-content-start w-50 mx-1">
                                            <span className="w-50 text-center">วันที่</span>
                                            <Field name="meetingDate">
                                                {({ field, meta, form }) => {
                                                    return (
                                                        <DatePicker
                                                            selected={field.value ? new Date(field.value) : null}
                                                            locale="th-buddhist"
                                                            showIcon
                                                            calendarClassName="thai-buddhist"
                                                            dateFormat="dd MMMM yyyy"
                                                            value={ConvertDateToThaiBuddhist(field.value)}
                                                            isClearable={true}
                                                            placeholderText="กรุณาเลือก"
                                                            renderCustomHeader={RenderCustomHeader}
                                                            onChange={(date) => {
                                                                form.setFieldValue(field.name, ConvertDateFormat(date))
                                                                setMeetingDate(ConvertDateFormat(date))
                                                            }}
                                                            customInput={
                                                                <Input
                                                                    type="text"
                                                                    className={
                                                                        touched.meetingDate && errors.meetingDate
                                                                            ? "input-error rounded-pill text-center input-color custom-placeholder"
                                                                            : "rounded-pill text-center input-color custom-placeholder"
                                                                    }
                                                                    value={ConvertDateToThaiBuddhist(field.value)}
                                                                    onChange={() => { }}
                                                                    onBlur={field.onBlur}
                                                                />
                                                            }
                                                        />
                                                    )
                                                }}
                                            </Field>

                                        </div>
                                    </Form>
                                </div>

                                <div style={{ overflowX: "auto" }} className="mt-3">
                                    <Table style={{ minWidth: "max-content", outline: "none" }} className="styled-table text-center" bordered {...getTableProps()}>
                                        <thead className='styles-thead'>

                                            {headerGroups.map((headerGroup) => {
                                                return (
                                                    <tr {...headerGroup.getHeaderGroupProps()}>
                                                        {headerGroup.headers.map((column) => {
                                                            return (
                                                                <th {...column.getHeaderProps()}>
                                                                    {column.render("Header")}
                                                                </th>
                                                            )

                                                        })}
                                                    </tr>
                                                )
                                            })}
                                        </thead>


                                        <tbody {...getTableBodyProps()}>
                                            {rows.map((row, i) => {
                                                prepareRow(row);
                                                for (let j = 0; j < row.allCells.length; j++) {
                                                    let cell = row.allCells[j];
                                                    let currentBorrowNumberForCheck = rowSpanHeaders.find((x) => x.id === "borrowNumber");

                                                    let rowSpanHeader = rowSpanHeaders.find((x) => x.id === cell.column.id);
                                                    if (rowSpanHeader !== undefined) {

                                                        if (rowSpanHeader.topCellValue === null || rowSpanHeader.topCellValue !== cell.value) {
                                                            cell.isRowSpanned = false;
                                                            rowSpanHeader.topCellValue = cell.value;
                                                            rowSpanHeader.topCellIndex = i;
                                                            cell.rowSpan = 1;
                                                        } else {
                                                            if (rowSpanHeader.id !== "borrowNumber") {
                                                                if (currentBorrowNumberForCheck.topCellValue !== data[i !== 0 ? i - 1 : 0].borrowNumber) {
                                                                    cell.isRowSpanned = false;
                                                                    rowSpanHeader.topCellValue = cell.value;
                                                                    rowSpanHeader.topCellIndex = i;
                                                                    cell.rowSpan = 1;
                                                                } else {
                                                                    if (rowSpanHeader.id === "inOutTypeName") {
                                                                        // console.log("inOutTypeName")
                                                                        if (data[i].testId === data[i !== 0 ? i - 1 : 0].testId) {
                                                                            rows[rowSpanHeader.topCellIndex].allCells[j].rowSpan++;
                                                                            cell.isRowSpanned = true;
                                                                        } else {
                                                                            cell.isRowSpanned = false;
                                                                            rowSpanHeader.topCellValue = cell.value;
                                                                            rowSpanHeader.topCellIndex = i;
                                                                            cell.rowSpan = 1;
                                                                        }
                                                                    } else if (rowSpanHeader.id === "testOccupationName" || rowSpanHeader.id === "testOccupationLevel") {
                                                                        if (data[i].testDetailId === data[i !== 0 ? i - 1 : 0].testDetailId) {
                                                                            rows[rowSpanHeader.topCellIndex].allCells[j].rowSpan++;
                                                                            cell.isRowSpanned = true;
                                                                        } else {
                                                                            cell.isRowSpanned = false;
                                                                            rowSpanHeader.topCellValue = cell.value;
                                                                            rowSpanHeader.topCellIndex = i;
                                                                            cell.rowSpan = 1;
                                                                        }

                                                                    } else if (rowSpanHeader.id === "dayAmount" || rowSpanHeader.id === "payment" || rowSpanHeader.id === "testEmployeeAmount" || rowSpanHeader.id === "startDate" || rowSpanHeader.id === "endDate") {

                                                                        if (data[i].testTimeId === data[i !== 0 ? i - 1 : 0].testTimeId) {
                                                                            rows[rowSpanHeader.topCellIndex].allCells[j].rowSpan++;
                                                                            cell.isRowSpanned = true;
                                                                        } else {
                                                                            cell.isRowSpanned = false;
                                                                            rowSpanHeader.topCellValue = cell.value;
                                                                            rowSpanHeader.topCellIndex = i;
                                                                            cell.rowSpan = 1;

                                                                        }
                                                                    } else {
                                                                        rows[rowSpanHeader.topCellIndex].allCells[j].rowSpan++;
                                                                        cell.isRowSpanned = true;
                                                                    }
                                                                }
                                                            } else {
                                                                rows[rowSpanHeader.topCellIndex].allCells[j].rowSpan++;
                                                                cell.isRowSpanned = true;
                                                            }
                                                        }
                                                    }


                                                }
                                                return null;
                                            })}


                                            {!page.length ? (
                                                <>
                                                    <tr>
                                                        <td className="text-center" colSpan="13">ไม่มีข้อมูล</td>
                                                    </tr>

                                                </>
                                            ) : (
                                                <>
                                                    {rows.map((row) => {
                                                        if (row.original.No > pageSize) {
                                                            return null
                                                        } else {
                                                            return (
                                                                <tr {...row.getRowProps()}>
                                                                    {row.cells.map((cell) => {
                                                                        if (cell.isRowSpanned) {
                                                                            return null;
                                                                        } else {
                                                                            return (
                                                                                <td rowSpan={cell.rowSpan} {...cell.getCellProps()}>
                                                                                    {cell.render("Cell")}
                                                                                </td>
                                                                            );
                                                                        }

                                                                    })}
                                                                </tr>
                                                            );
                                                        }
                                                    })}
                                                </>
                                            )}

                                        </tbody>
                                    </Table>

                                </div>

                                {/* <div className="outer-wrapper">
                                    <div className="table-wrapper">
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th rowSpan="3">ลำดับ</th>
                                                    <th rowSpan="3">เลขที่คำขอ</th>
                                                    <th rowSpan="3">ผู้ขอกู้</th>
                                                    <th colSpan="2">ประเภทกู้ยืม</th>
                                                    <th rowSpan="3">ประเภทกิจการ</th>
                                                    <th rowSpan="3">จำนวนลูกจ้างทั้งสิ้น(คน)</th>
                                                    <th colSpan="10">รายละเอียดกู้ยืม</th>
                                                    <th colSpan="2">หลักประกัน(บุคคลค้ำประกัน)</th>
                                                    <th rowSpan="3">หน่วยงานที่รับคำขอกู้ยืมเงิน</th>
                                                </tr>
                                                <tr>
                                                    <th rowSpan="2">ผู้ดำเนินการทดสอบ</th>
                                                    <th rowSpan="2">ผู้ประกอบกิจการ</th>
                                                    <th colSpan="2">การดำเนินการทดสอบ</th>


                                                    <th rowSpan="2">สาขาอาชีพ</th>
                                                    <th rowSpan="2">สาขา</th>
                                                    <th rowSpan="2">ระดับ</th>
                                                    <th rowSpan="2">ระยะเวลาฝึกอบรม (ชั่วโมง)</th>
                                                    <th rowSpan="2">วันที่เริ่มฝึก</th>
                                                    <th rowSpan="2">วันที่จบการฝึก</th>
                                                    <th rowSpan="2">จำนวน (คน)</th>
                                                    <th rowSpan="2">รวมวงเงินที่ขอกู้ (บาท)</th>
                                                    <th rowSpan="2">ชื่อ-สกุล</th>
                                                    <th rowSpan="2">ตำแหน่ง</th>
                                                </tr>
                                                <tr>
                                                    <th >ทดสอบเอง</th>
                                                    <th >ส่งไปฝึก</th>

                                                </tr>
                                            </thead>
                                            <tbody>
                                                {!data.length ? (
                                                    <tr>
                                                        <td className="text-center border-none" colSpan={9}>ไม่พบข้อมูล</td>
                                                    </tr>
                                                ) : (
                                                    <>
                                                        {data.map((item, i) => (
                                                            <tr key={i}>
                                                                <td>{i + 1}</td>
                                                                เลขที่คำขอกู้ยืมเงิน
                                                                <td>{item.borrowNumber}</td>
                                                                ชื่อผู้ขอกู้ยืม
                                                                <td>{item.employee}</td>
                                                                ประเภทการสมัคร
                                                                <td>{item.typeTrain ? <TiTick /> : "-"}</td>
                                                                ประเภทกิจการ
                                                                <td>{item.typeComp ? <TiTick /> : "-"}</td>
                                                                ทุนจดทะเบียน 
                                                                <td>{item.businessType}</td>
                                                                <td className="text-center">{item.employeeAmount}</td>
                                                                <td>{item.employeeAmount}</td>
                                                                <td className="text-center">{item.lift ? <TiTick /> : "-"}</td>
                                                                <td className="text-center">{item.change ? <TiTick /> : "-"}</td>
                                                                <td>{item.lawOccupationName}</td>
                                                                <td>{item.testOccupationName}</td>
                                                                <td className="text-center">{item.stdLevelTname}</td>
                                                                <td>-</td>
                                                                <td>{item.startDate}</td>
                                                                <td>{item.endDate}</td>
                                                                <td className="text-center">{item.personTotal}</td>
                                                                <td className="text-center">{NumberWithCommas(item.amountLimit)}</td>
                                                                <td>{item.name}</td>
                                                                <td>{item.position}</td>
                                                                <td>{item.site}</td>
                                                            </tr>

                                                        ))}
                                                    </>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div> */}
                            </>
                        ) : (<Loading />)}

                    </Container>





                )
            }}


        </Formik>




    )

}